<template>
  <div class="page">
    <transition name="el-fade-in-linear">
      <el-row v-show="show">
        <el-col :span="14">
          <h1 class="bienvenue">BIENVENUE </h1>
          <h1 class="marketplace">SUR LA MARKETPLACE!</h1></el-col>
        <el-col :span="10">
          <Card with-shadow>
            <div class="connexion--type">
              <el-link type="primary"
                       class="link first--link"
                       :underline="false"
                       @click="pushToShopAuth">Je me connecte en tant que magasin
              </el-link>
              <hr>
              <el-link type="success"
                       class="link second--link"
                       :underline="false"
                       @click="pushToADAuth">Je me connecte en tant que responsable de secteur
              </el-link>
            </div>
          </Card>
        </el-col>
      </el-row>
    </transition>
  </div>
</template>

<script>
  import Card from '../../components/Card/Card.vue';

  export default {
    components: {
      Card,
    },
    data() {
      return {
        show: true,
      };
    },
    methods: {
      pushToShopAuth() {
        this.show = false;
        this.$router.push({ name: 'ShopSignIn' });
      },

      pushToADAuth() {
        this.show = false;
        this.$router.push({ name: 'ADAuth' });
      },
    },
  };
</script>

<style lang="stylus">
  .connexion--type {
    width auto
    display flex
    flex-direction: column;
    justify-content: center;
    align-items center;
    align-content center
    padding 20px
  }

  .page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  hr {
    margin: 0;
    align-self: stretch;
  }

  h1 {
    font-size 3rem
  }

  .bienvenue {
    color #5daf34

  }

  .marketplace {
    color #2a8eec
  }

  .link {
    font-size 1.2rem
  }

  .first--link {
    margin-bottom 20px
  }

  .second--link {
    margin-top 20px
  }
</style>
